import React from 'react'
import { connect } from 'react-redux'
import { RocketOutlined } from '@ant-design/icons'
import './loading.css'

const mapStateToProps = (state) => {
  return {
    showLoading: state.showLoading
  }
}

const Loading = (props) => {
  return (
    <>
      {
        props.showLoading ? (
          <div className="spxLoadMain">
            <div className="spxLoadBox">

              <div className="spxLoadRocketWrap">
                <RocketOutlined className="spxLoadRocketIcon" />
              </div>

              <div className="spxLoadText">
                LOADING
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </div>

            </div>
          </div>
        ) : null
      }
    </>
  )
}

export default connect(mapStateToProps)(Loading)